export interface IOrganizationDTO {

    id?: string | null
    directionId?: string | null
    region?: string | null
    code?: string | null
    fullName?: string | null
    shortName?: string | null
    legalForm?: string | null
    subordinatedToId?: string | null
    subordinatedToFullName?: string | null
    subordinatedToFullNameUa?: string | null
    subordinatedToFullNameEn?: string | null
    subordinatedToShortName?: string | null
    subordinatedToShortNameUa?: string | null
    subordinatedToShortNameEn?: string | null

    useActualAddress?: boolean | null
    type?: string | null
    status?: string | null
    memberConnectionStatus?: string | null
    isSpecial?: boolean | null
    regionId?: string | null
    regionName?: string | null
    regionCode?: string | null

    formalAddress?: string | null
    actualAddress?: string | null
    facilityPhone?: string | null
    facilityEmail?: string | null
    headFirstName?: string | null
    headLastName?: string | null
    headMiddleName?: string | null
    headPhone?: string | null

}

export class OrganizationViewModel implements IOrganizationDTO {

  constructor(model?: Partial<IOrganizationDTO>) {
    if (model) {
      Object.assign(this, model);
    }
  }

  id?: string | null;
  directionId?: string | null;
  region?: string | null;
  code?: string | null;
  fullName?: string | null;
  shortName?: string | null;
  legalForm?: string | null;
  subordinatedToId?: string | null;
  subordinatedToFullName?: string | null;

  subordinatedToFullNameUa?: string | null;
  subordinatedToFullNameEn?: string | null;
  subordinatedToShortName?: string | null;
  subordinatedToShortNameUa?: string | null;
  subordinatedToShortNameEn?: string | null;

  useActualAddress?: boolean | null;
  type?: string | null;
  status?: string | null;
  memberConnectionStatus?: string | null;
  isSpecial?: boolean | null;
  regionId?: string | null;
  regionName?: string | null;
  regionCode?: string | null;

  formalAddress?: string | null;
  actualAddress?: string | null;
  facilityPhone?: string | null;
  facilityEmail?: string | null;
  headFirstName?: string | null;
  headLastName?: string | null;
  headMiddleName?: string | null;

  getHeadFullName(): string {
    return [this.headLastName, this.headFirstName, this.headMiddleName].filter(it => !!it).join(" ");
  }
}
